export default defineNuxtRouteMiddleware(() => {
  const userState = useUserState()
  if (userState.value.tokenPair)  {
    console.log('token found, redirecting...')
    return navigateTo('/users')
  }
})
